import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'utils/stringUtils';
import { RoiSummary } from '../types';

interface Props {
  summary: RoiSummary;
}

const SummaryCards: React.FC<Props> = ({ summary }) => {
  const { t } = useTranslation('admin');
  const hitRatePct = Math.round(summary.effectiveHitRate * 100);

  return (
    <div className="roi-summary-cards">
      <div className="roi-card roi-card--savings">
        <div className="roi-card-label">{t('roiInsights.cards.savingsThisPeriod')}</div>
        <div className="roi-card-value">{formatCurrency(summary.estimatedCostAvoided)}</div>
      </div>
      <div className="roi-card roi-card--savings">
        <div className="roi-card-label">{t('roiInsights.cards.projectedSavings')}</div>
        <div className="roi-card-value">{formatCurrency(summary.projectedAnnualSavings)}</div>
      </div>
      <div className="roi-card">
        <div className="roi-card-label">{t('roiInsights.cards.totalRequests')}</div>
        <div className="roi-card-value">{summary.totalRequests.toLocaleString('en-US')}</div>
      </div>
      <div className="roi-card">
        <div className="roi-card-label">{t('roiInsights.cards.hitsServedByVs')}</div>
        <div className="roi-card-value">{summary.hitsServedByVs.toLocaleString('en-US')}</div>
      </div>
      <div className="roi-card">
        <div className="roi-card-label">{t('roiInsights.cards.accountHitRate')}</div>
        <div className="roi-card-value">{hitRatePct}%</div>
      </div>
      <div className="roi-card">
        <div className="roi-card-label">{t('roiInsights.cards.activeServices')}</div>
        <div className="roi-card-value">
          {summary.activeServiceCount}
          <span className="roi-card-value-suffix">
            {' '}
            {t('roiInsights.cards.activeServicesOf', { total: summary.totalServiceCount })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SummaryCards;
